// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'evaluacion-colegios',
    appId: '1:403692029966:web:f0f1f45bfeb48882c3d45f',
    storageBucket: 'evaluacion-colegios.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyAWYB58X6H8Kfb0WqpHwP07t4Tc7vY5VQA',
    authDomain: 'evaluacion-colegios.firebaseapp.com',
    messagingSenderId: '403692029966',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
